module.exports = __webpack_public_path__ + "img/fullLogo.f260c16b.svg";